import React, { useState, useEffect } from "react";
import { useUserData } from "components/customHooks/userDataContext";
import { getProviderList } from "apiHandler/actions";
import { colorArray } from "components/helpers";
import LoaderModal from "./LoaderModal";

import Chat from "components/chat/Chat";
import "./style.scss";
import { Avatar } from "@mui/material";

const MessageChat = () => {
  const [show, setShow] = useState(false);
  const [members, setMembers] = useState(null);
  const [selMember, setSelMember] = useState(null);
  const userData = useUserData();
  const token = userData?.access_token;

  useEffect(() => {
    setShow(true);
    const getMemberList = async () => {
      const payload = {
        practice_id: userData.selected_practice,
      };
      let response = await getProviderList(payload, token);
      if (response !== "ERROR") {
        setMembers(response || []);
        setShow(false);
      } else setMembers([]);
    };
    getMemberList();
  }, []);

  const membersColorArray = members?.map((el, i) => {
    return {
      ...el,
      color: colorArray[i],
    };
  });

  const handleOnClick = (m) => {
    setSelMember(m);
    setShow(true);
  };

  return (
    <div className="home">
      <div className="container">
        <div className="sidebar">
          <div className="search">
            <div className="searchform">
              <h3 style={{ color: "white" }}>Messages</h3>
            </div>
          </div>
          {membersColorArray?.map((m) => (
            <div
              key={m.npi}
              className="chats"
              onClick={() => handleOnClick(m)}
              style={{ backgroundColor: m.color }}
            >
              <div className="userchat">
                <Avatar
                  alt="Cindy Baker"
                  sx={{
                    width: "50px",
                    height: "50px",
                    borderRadius: "50%",
                    objectFit: "cover",
                    backgroundColor: "#A9A9A9",
                  }}
                >
                  {m.first_name.slice(0, 1) + " " + m.last_name.slice(0, 1)}
                </Avatar>
                <div className="userChatInfo">
                  <span>{m.first_name}</span>
                </div>
              </div>
            </div>
          ))}
        </div>
        <Chat {...selMember} setShow={setShow} />
      </div>
      {show && <LoaderModal show={show} setShow={setShow} />}
    </div>
  );
};

export default MessageChat;
